export class InterfaceError extends Error {
  constructor(message, cause) {
    super(message);
    this.cause = cause;
    this.name = 'InterfaceError';
  }
}
